/**
 * @flow
 */

import {
  ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS,
  ON_MY_TICKETS_PAST_MOUNT_SUCCESS,
  PAGINATION_MORE_ORDERS,
  PAGINATION_SET_PAGE
} from '../actions';

const initialState = {
  loadingPagination: false,
  currentPagination: {},
  pastPagination: {},
  currentPage: 1,
  pastPage: 1
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case PAGINATION_MORE_ORDERS:
      return Object.assign({}, state, {
        loadingPagination: true
      });

    case PAGINATION_SET_PAGE:
      const isCurrent = action.payload.isCurrentOrPast === 'current';
      const isPast = action.payload.isCurrentOrPast === 'past';

      return Object.assign({}, state, {
        currentPage: isCurrent ? action.payload.page : state.currentPage,
        pastPage: isPast ? action.payload.page : state.pastPage
      });

    case ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS:
      return Object.assign({}, state, { loadingPagination: false, currentPagination: action.payload.meta });

    case ON_MY_TICKETS_PAST_MOUNT_SUCCESS:
      return Object.assign({}, state, { loadingPagination: false, pastPagination: action.payload.meta });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/my-tickets/reducers/pagination.js